(function (app, ng) {

    /*
Service figModalState
Convenience service for registering a state that is wrapped in a modal ($mdDialog)
    - when the app transitions to the state, it will open up a modal
    - when the app transitions away from the state, the modal will close
    - if the modal closes without a state transition, got to its parent state

Because of this, states that use this don't need to manually call $mdDialog.hide or cancel
Instead, they can just navigate to another state with $state.go or similar

State definitions can pass in a component, or a template/templateUrl/controller/controllerAs

instead of your usual:
    $stateProvider.state("Some.State", {url:'', component:'', resolves:{}})
you can now do:
    figModalState.state("Some.Modal.State", {url:'', component:'', resolves:{}})

TODO: this needs work to be a fully functional state, right now it has some limitations:
    - onEnter and onExit are used to trigger modal states - if you want to provide your own onEnter/exit for the controller, they'll be overwritten
        - can be fixed if we pass the original onEnter to the new onEnter along with $injector and run it, same for onExit

     */
    app.provider("figModalState",
    [
        "$stateProvider", function ($stateProvider) {
            this.$get = [function () { return {}; }];

            this.state = registerState;

            var defaultOptions = {
                method: "alert",
                clickOutsideToClose: true
            };

            function registerState(name, state, options) {
                options = ng.extend({}, defaultOptions, options);
                var key = {};
                $stateProvider.state(name,
                {
                    url: state.url,
                    params: state.params,
                    resolve: state.resolve,
                    onEnter: [
                        "$mdDialog", "figUiSrefModalService", "$state", "figModalComponent", "$transition$",
                        function ($mdDialog, figUiSrefModalService, $state, figModalComponent, $transition$) {
                            var alert;
                            var locals = {};

                            for (var property in state.resolve) {
                                if (state.resolve.hasOwnProperty(property)) {
                                    locals[property] = $transition$.injector().get(property);
                                }
                            }

                            if (state.component) {
                                alert = figModalComponent[options.method]({
                                    component: state.component,
                                    targetEvent: figUiSrefModalService.$event,
                                    clickOutsideToClose: options.clickOutsideToClose,
                                    parent: options.parent,
                                    locals: locals
                                });
                            } else {
                                alert = $mdDialog[options.method]({
                                    template: state.template,
                                    templateUrl: state.templateUrl,
                                    controller: state.controller,
                                    controllerAs: state.controllerAs,
                                    targetEvent: figUiSrefModalService.$event,
                                    clickOutsideToClose: options.clickOutsideToClose,
                                    parent: options.parent,
                                    locals: locals
                                });
                            }
                            $mdDialog.show(alert).then(goToParent, goToParent);

                            function goToParent(val) {
                                if (val !== key)
                                    $state.go("^");
                            }
                        }
                    ],
                    //here we send a key - that lets us know that the state was exited before the dialog close was requested
                    //that means we are already transitioning and don't need to $state.go("^")
                    onExit: ["$mdDialog", function ($mdDialog) { $mdDialog.hide(key); }]
                });
            }
        }
    ]);

})(window.app, window.angular); // jshint ignore:line